import React from "react";
import { Box, Chip, Stack, Typography, alpha, useTheme } from "@mui/material";
import StarOutlined from "@mui/icons-material/StarOutlined";
import { MODEL_TIER_LABELS, categoryModelNote, modelsForCategory } from "../categories";

const TIER_STYLE = {
  best: { color: "#0F6E56", bg: "#E1F5EE", border: "#5DCAA5" },
  alt: { color: "#185FA5", bg: "#E6F1FB", border: "#85B7EB" },
  budget: { color: "#854F0B", bg: "#FAEEDA", border: "#EF9F27" },
};

export default function ComingSoonPanel({ category, lang }) {
  const theme = useTheme();
  const Icon = category?.icon;
  const models = modelsForCategory(category);
  const note = categoryModelNote(category, lang);

  return (
    <Box
      sx={{
        p: { xs: 3, md: 5 },
        borderRadius: 2,
        border: `1px dashed ${theme.palette.divider}`,
        bgcolor: alpha(theme.palette.primary.main, 0.03),
        textAlign: "center",
        minHeight: 360,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack spacing={2} alignItems="center" maxWidth={480}>
        {Icon && (
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: alpha(theme.palette.text.disabled, 0.08),
              color: "text.disabled",
            }}
          >
            <Icon sx={{ fontSize: 32, opacity: 0.5 }} />
          </Box>
        )}
        <Typography variant="h6" fontWeight={800}>
          {lang?.videoStudioComingSoonTitle || "Coming soon"}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {lang?.videoStudioComingSoonBody ||
            "This use case is next on the roadmap. Try Product in Hand, UGC Ads, Product Showcase, Multi-Shot, or E-Commerce."}
        </Typography>

        <Box sx={{ width: "100%", textAlign: "left" }}>
          <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" mb={1}>
            {lang?.videoStudioRecommendedModels || "Recommended models"}
          </Typography>
          <Stack direction="row" flexWrap="wrap" gap={0.75}>
            {models.map((m) => {
              const tierMeta = MODEL_TIER_LABELS[m.tier];
              const style = TIER_STYLE[m.tier] || TIER_STYLE.alt;
              return (
                <Chip
                  key={m.id}
                  size="small"
                  icon={m.tier === "best" ? <StarOutlined sx={{ fontSize: 14 }} /> : undefined}
                  label={`${m.label} · ${lang?.[tierMeta.key] || tierMeta.fallback}`}
                  sx={{
                    fontWeight: 600,
                    color: style.color,
                    bgcolor: style.bg,
                    border: `1px solid ${style.border}`,
                    "& .MuiChip-icon": { color: style.color },
                  }}
                />
              );
            })}
          </Stack>
          {note && (
            <Typography variant="caption" color="text.secondary" display="block" mt={1.5} lineHeight={1.55}>
              {note}
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
